/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/explicit-member-accessibility */
import { wasteManagementUrls } from '../appConfig';
import { IDriver } from '../models/Driver.model';
import wasteManagementClient from './wasteManagementClient';

export default class DriverService {
  static async getContractorDrivers(
    contractorId: number,
    ignoreCache = false,
  ): Promise<Array<IDriver>> {
    try {
      const response = await wasteManagementClient.get(
        wasteManagementUrls.driver,
        {
          params: { contractorId },
          cache: { ignoreCache },
        },
      );
      if (response?.status === 200 && response.data) {
        return response.data;
      } else {
        return [];
      }
    } catch (err) {
      console.error(err);
      throw new Error(err);
    }
  }

  static async createNewDriver(
    newDriver: IDriver,
    ignoreCache = false,
  ): Promise<IDriver> {
    try {
      const response = await wasteManagementClient.post(
        wasteManagementUrls.driver,
        newDriver,
        { cache: { ignoreCache } },
      );
      if (response.status === 200) {
        return response.data;
      } else {
        return null;
      }
    } catch (error) {
      console.error(error);
      throw new Error(error);
    }
  }

  static async updateDriver(
    driver: IDriver,
    ignoreCache = false,
  ): Promise<IDriver> {
    try {
      const response = await wasteManagementClient.put(
        wasteManagementUrls.driver,
        driver,
        { cache: { ignoreCache } },
      );
      if (response.status === 200) {
        return response.data;
      } else {
        return null;
      }
    } catch (error) {
      console.error(error);
      throw new Error(error);
    }
  }

  static async deleteDriver(
    customerId: number,
    contractorId: number,
    driverName: string,
  ): Promise<IDriver> {
    try {
      const response = await wasteManagementClient.delete(
        wasteManagementUrls.driver,
        {
          params: {
            customerId,
            contractorId,
            driverName,
          },
        },
      );
      if (response.status === 200) {
        return response.data;
      } else {
        return null;
      }
    } catch (error) {
      console.error(error);
      throw new Error(error);
    }
  }
}
